import { generator } from '../event-listener.js';
export const OnClick = generator('onClick');
export const OnDoubleClick = generator('onDoubleClick');
export const OnContextMenuClick = generator('onContextMenu');
//# sourceMappingURL=clickable.js.map